import { render, staticRenderFns } from "./KeyboardGrid.vue?vue&type=template&id=1a7d0d49&scoped=true"
import script from "./KeyboardGrid.vue?vue&type=script&lang=ts"
export * from "./KeyboardGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7d0d49",
  null
  
)

export default component.exports